import React from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelInput as Input } from '../../../../Elements';

const TextArrayWidget = ({ onChange, formData }) => (
  <Input
    name='textWidget'
    value={formData}
    autoHeight
    placeholder='Your answer'
    onChange={(e) => onChange(e.target.value)}
  />
);

TextArrayWidget.propTypes = {
  formData: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default TextArrayWidget;



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Widgets/TextList.js